import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { providersOfMeBasicSelectors } from 'redux/providersOfMeBasic/selectors';

import { RestInputContext } from 'components/RestInput/RestInputContext';
import ListCheckboxSelect from './ListCheckboxSelect';

const ProviderListSelect = ({ retrieveList }) => {
  const { record } = useContext(RestInputContext);
  const data = useSelector(providersOfMeBasicSelectors.getDataArr);
  const paging = useSelector(providersOfMeBasicSelectors.getResourceData);
  const loading = useSelector(providersOfMeBasicSelectors.getLoading);

  const defaultValue = useMemo(
    () => record.providers?.map((item) => item?.id),
    [record.providers],
  );

  return (
    <ListCheckboxSelect
      retrieveList={retrieveList}
      name="providerIds"
      defaultValue={defaultValue}
      data={data}
      paging={paging}
      messageRequired="users.selectProviderRequired"
      selectedResourceTitles="users.selectedProvidersTotal"
      selectedResourceTitle="users.selectedProviderTotal"
      loading={loading}
    />
  );
};

ProviderListSelect.propTypes = {
  retrieveList: PropTypes.func,
};

export default ProviderListSelect;
